import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingOutlined = _resolveComponent("LoadingOutlined")!
  const _component_IconUpDown = _resolveComponent("IconUpDown")!
  const _component_Spin = _resolveComponent("Spin")!
  const _component_Cos_Select = _resolveComponent("Cos-Select")!

  return (_openBlock(), _createBlock(_component_Cos_Select, _mergeProps({
    value: _ctx.state,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state) = $event))
  }, _ctx.$attrs, {
    "allow-clear": _ctx.allowClear,
    options: _ctx.innerOptions,
    placeholder: _ctx.placeholder,
    mode: _ctx.mode,
    "max-tag-count": _ctx.maxTagCount,
    "max-tag-text-length": _ctx.maxTagTextLength,
    "show-arrow": _ctx.showArrow,
    onChange: _ctx.handleChange,
    onDropdownVisibleChange: _ctx.handleVisibleChange
  }), _createSlots({ _: 2 }, [
    _renderList(Object.keys(_ctx.$slots), (slot) => {
      return {
        name: slot,
        fn: _withCtx((data) => [
          _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps(data || {})))
        ])
      }
    }),
    (_ctx.loading || _ctx.isMultipleMode)
      ? {
          name: "suffixIcon",
          fn: _withCtx(() => [
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_LoadingOutlined, {
                  key: 0,
                  spin: ""
                }))
              : (_openBlock(), _createBlock(_component_IconUpDown, { key: 1 }))
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.loading)
      ? {
          name: "notFoundContent",
          fn: _withCtx(() => [
            _createVNode(_component_Spin, { size: "small" })
          ]),
          key: "1"
        }
      : undefined
  ]), 1040, ["value", "allow-clear", "options", "placeholder", "mode", "max-tag-count", "max-tag-text-length", "show-arrow", "onChange", "onDropdownVisibleChange"]))
}